import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/looks.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
